export default function RowMerakiLicence({ item }) {
    const counts = Array.isArray(item?.counts) ? item.counts : [];

    return (
        <>
            <div className="meraki">
                {counts.map(count => {
                    return (
                        <div className="meraki-item" key={count.model}>
                            <span className="meraki-title">{count.model}</span>
                            <span className="meraki-content">{count.count}</span>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
